var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 20.8333L25.8346 20.8333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 25.8333L20.8346 25.8333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16797 8.23333C9.16797 7.39325 9.16797 6.97321 9.33146 6.65234C9.47527 6.3701 9.70474 6.14063 9.98698 5.99682C10.3079 5.83333 10.7279 5.83333 11.568 5.83333H21.5072C21.8741 5.83333 22.0575 5.83333 22.2301 5.87477C22.3832 5.91152 22.5295 5.97212 22.6637 6.05437C22.8151 6.14713 22.9448 6.27684 23.2042 6.53627L30.1317 13.4637C30.3911 13.7231 30.5208 13.8529 30.6136 14.0042C30.6958 14.1384 30.7564 14.2848 30.7932 14.4378C30.8346 14.6104 30.8346 14.7939 30.8346 15.1608V31.7667C30.8346 32.6067 30.8346 33.0268 30.6711 33.3476C30.5273 33.6299 30.2979 33.8594 30.0156 34.0032C29.6948 34.1667 29.2747 34.1667 28.4346 34.1667H11.568C10.7279 34.1667 10.3079 34.1667 9.98698 34.0032C9.70474 33.8594 9.47527 33.6299 9.33146 33.3476C9.16797 33.0268 9.16797 32.6067 9.16797 31.7667V8.23333Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.832 5.83333V13.4333C20.832 14.2734 20.832 14.6934 20.9955 15.0143C21.1393 15.2966 21.3688 15.526 21.651 15.6698C21.9719 15.8333 22.392 15.8333 23.232 15.8333H30.832",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.0c37749381a429c7ef73b2cd72e0b520.svg";
export { ForwardRef as ReactComponent };